import { AnySourceStream, Stream } from '../stream'
import { Pass } from './pass'

export class OnError<SV, SE = any, SC = any> extends Pass<SV, SE, SC> {
    protected onErrorFn: (value: SE) => any

    constructor(onErrorFn: (value: SE) => any, source?: AnySourceStream<SV, SE, SC>) {
        super(source)
        this.onErrorFn = onErrorFn
    }

    error(error: SE) {
        try {
            this.onErrorFn(error)
        } catch (e) {
            this._error(e as any)
        }
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        onError<T>(onError: (error: SE) => any): Stream<DV, DE, DC, DV, DE, DC>
    }
}

Stream.prototype.onError = function <SV, SE, SC>(this: AnySourceStream<SV, SE, SC>, onError: (error: SE) => any) {
    return new OnError(onError, this) // tslint:disable-line:no-invalid-this
}
